import { TIMELINE_CLUSTER_THRESHOLD } from "constants/filingsTimeline";
import { TimelineFilingRow } from "store/apis/filingsTimeline";
import { getYearFraction } from "./getYearFraction";

export type TimelineMarkerGroup = {
  fraction: number;
  filings: TimelineFilingRow[];
};

type PendingGroup = {
  first: number;
  last: number;
  filings: TimelineFilingRow[];
};

export const groupFilingsByProximity = (
  filings: TimelineFilingRow[],
  year: number
): TimelineMarkerGroup[] => {
  const sorted = [...filings].sort((a, b) =>
    a.deadline.localeCompare(b.deadline)
  );

  const grouped = sorted.reduce<PendingGroup[]>((groups, filing) => {
    const fraction = getYearFraction(filing.deadline, year);
    const lastGroup = groups[groups.length - 1];

    if (
      lastGroup &&
      Math.abs(fraction - lastGroup.last) < TIMELINE_CLUSTER_THRESHOLD
    ) {
      lastGroup.last = fraction;
      lastGroup.filings.push(filing);
      return groups;
    }

    return [...groups, { first: fraction, last: fraction, filings: [filing] }];
  }, []);

  return grouped.map(({ first, last, filings: groupFilings }) => ({
    fraction: (first + last) / 2,
    filings: groupFilings,
  }));
};
